(function(){
"use strict"
document.addEventListener("DOMContentLoaded", function() {
var html = document.documentElement,
    supportwebp = html.classList.contains("webp");
var _data = portfolio;
var webp = "image/app.webp"
var gridComponent = function (props) {
        return ` <li class="work-grid">
                   ${props.page !== "#" ? `<a  href="${props.page}" class="w-link">` : ''}
                    <section>
                        <div class="work-img-holder">
                           <div class='work-img-true' ${props.category === "general" ? `style='background-image: url(${supportwebp ? props.webp : props.image})'` : ''}>
                                ${props.category !== "general" ? `<picture>
                                <source srcset="${props.webp}" type="image/webp">
                                <img src='${props.image}' alt='${props.name}' class='work-image-logo'>
                                </picture>`
                                 : ''}
                                 ${props.category !== "general" ? `<p class='p text-dim sch-name'> ${props.name} </p>` : ''}
                           </div>
                           <div class='work-desc ${props.name.split(' ')[0]}'>
                            <article> 
                            ${props.category === "general" ? `<h4>  ${props.name} </h4>` : ''}
                                <p class='d'> ${props.desc} </p>
                                <div class="available-div">
                               ${props.page === "#" ? `<object>
                                <p class='available'>
                                    ${props.available.android ? `<span> <a target='_blank' class='button button-small' href='${props.available.android}'>  Play Store </a> </span>` : ""}
                                    ${props.available.ios ? `<span> <a target='_blank' class='button button-small' href='${props.available.ios}'> App Store </a> </span>` : ""}
                                    ${props.available.web ? `<span> <a target='_blank' class='button button-small' href='${props.available.web}'> Visit Website </a> </span>` : ""}
                                </p>
                                </object>`  : '' }
                            </article>
                        </div>
                       </div> 
                    </section>
                    <h4 class='w-title'> ${props.name} </h4>  
                 ${props.page !== "#" ?   '</a>' : ''}
                </li> `
    }
var viewComponent = function (portfolio) {
    return `<ul class=' clearfix  work-ul'>
            ${portfolio.map(gridComponent).join('')}
            </ul>`       
}
var filterBy = function (data, val) {
    var filters = data.filter(function(list){
        var a = list.category.toLowerCase(),
            b = val.toLowerCase()
            return a == b
        })
    return filters   
}
    
var render = function (category) {
    var data = filterBy(_data, category)
    document.getElementById("portfolioView").innerHTML = viewComponent(data)
}
var toggle = function(view){
    document.getElementById(view).classList.toggle("hide");
}
var manageActive = function (el, lefts, color) {
    var tabs = document.getElementsByClassName("r-tab")
    Array.prototype.forEach.call(tabs, function (el){
       el.classList.remove("tabNow")
    })
    el.classList.add("tabNow")
    el.classList.add("loaded")
    var line = document.getElementById("activeLine")
    line.style.left = lefts
    line.style.background = color
}
var slogan = document.getElementById("sloganTitle")
var bgbox = document.getElementById("dynamicbg")
var addSlogan = function (text, image) {
    slogan.innerHTML = "<span>" +  text + "</span>"
    bgbox.style.backgroundImage = "url(" + image + ")"
}

var currentHash = window.location.hash
if(currentHash === "#eatery") {
  setTimeout(function() {
  render("eatery")  
  manageActive(document.getElementById("eaterytab"), "66.6666%", "#e91e63")
  addSlogan(" Connecting Restaurants with their customers", (!supportwebp) ? "image/hero/eatery.jpg" : "webp/hero/eatery.webp" ) 
  }, 20);  
}else if (currentHash === "#veda") {
  setTimeout(function() {
   render("veda") 
   manageActive(document.getElementById("vedatab"), "33.3333%", "#6c12b0")
    addSlogan("Véda  - Connecting Schools & Parents.", (!supportwebp) ? "image/hero/veda_home.jpg" : "webp/hero/veda_home.webp")
  }, 20);
}else {
   setTimeout(function() {
    render("general")
    manageActive(document.getElementById("generaltab"), "0%", "#3996a8")
}, 20);
}
var generalTab = document.getElementById("generaltab"),
    vedaTab = document.getElementById("vedatab"),
    eateryTab = document.getElementById("eaterytab");

    generalTab.addEventListener("click", function () {
        if(this.classList.contains("tabNow") === false) {
            render("general")
            manageActive(this, "0%", "#3996a8")
            addSlogan("inGrails Brief Bag", (!supportwebp) ? "image/hero/work.jpg" : "webp/hero/work.webp")
        }
    })
    vedaTab.addEventListener("click", function () {
        if(this.classList.contains("tabNow") === false) {
            render("veda")
            manageActive(this, "33.3333%", "#6c12b0")
            addSlogan("Véda  - Connecting Schools & Parents.", (!supportwebp) ? "image/hero/veda_home.jpg" : "webp/hero/veda_home.webp")
        }
    })
    eateryTab.addEventListener("click", function () {
        if(this.classList.contains("tabNow") === false) {
            render("eatery")
            manageActive(this, "66.6666%", "#e91e63")
            addSlogan(" Connecting Restaurants with their customers", (!supportwebp) ? "image/hero/eatery.jpg" : "webp/hero/eatery.webp")
         }
    })
 })
})()

